import styled, { css } from 'styled-components';

import { media } from './breakpoints';

const setWidth = (columns) => {
  return Object.keys(columns).map((breakpoint) => {
    const columnWidth = (columns[breakpoint] / 12) * 100;
    const hideColumn = columns[breakpoint] === 0;

    if (breakpoint === 'phone') {
      return css`
        display: ${hideColumn ? 'none' : 'block'};
        width: ${columnWidth}%;
      `;
    }

    return css`
      ${media[breakpoint]`
        display: ${hideColumn ? 'none' : 'block'};
        width: ${columnWidth}%;
      `}
    `;
  });
};

const setJustify = (justify) => {
  return css`
    justify-content: ${justify};
  `;
};

const Column = styled.div`
  ${({ size }) => size && setWidth(size)}
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  ${({ justify }) => justify && setJustify(justify)}

  ${/* sc-selector */ Column} {
    ${media.tablet`
      ${({ gutter }) => gutter && 'padding: 10px'};
    `};
  }

  ${media.tablet`
    flex-wrap: nowrap
  `};
`;

Row.Column = Column;
